'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M96 0l64 0C203.2 0 240.3 26.4 256 63.9 271.7 26.4 308.8 0 352 0l72 0 0 40c0 18.7-4.9 36.2-13.5 51.3-5.2-1.8-10.4-3.4-15.8-4.8 8.4-13.5 13.3-29.4 13.3-46.5l0-24-56 0c-45 0-82.2 33.9-87.4 77.5-5.7 .6-11.5 .6-17.2 0-5.2-43.7-42.3-77.5-87.4-77.5l-56 0 0 24c0 17.1 4.9 33 13.3 46.5-5.3 1.4-10.6 3-15.7 4.8-8.6-15.1-13.5-32.7-13.5-51.3l0-40 8 0zM0 280c0-92.8 75.2-168 168-168 32.3 0 62.4 9.1 88 24.9 25.6-15.8 55.7-24.9 88-24.9 92.8 0 168 75.2 168 168 0 152-248 232-248 232l-16 0S0 432 0 280zM283.4 156c32.2 26.2 55.8 62.3 55.8 100l0 8-16 0 0-8c0-31.1-19.7-63-49.9-87.6-30.1-24.5-69.1-40.4-105.3-40.4-83.9 0-152 68.1-152 152 0 67 55.1 120.8 116.5 159.5 30.1 18.9 60.2 33.3 83 42.9 11.3 4.8 20.8 8.4 27.3 10.8 3.3 1.2 5.8 2.1 7.6 2.7l.2 .1 10.8 0 .2-.1c1.7-.6 4.3-1.5 7.6-2.7 6.6-2.4 16-6 27.3-10.8 22.7-9.7 52.9-24 83-42.9 61.5-38.7 116.5-92.5 116.5-159.5 0-83.9-68.1-152-152-152-26.5 0-51.4 6.8-73 18.6 4.3 3 8.4 6.1 12.4 9.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;